import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IDataSummaryResponse, IDataSummaryResult } from "./index.type";

const useGetBillingDataSummaryPdfPage = ({
  billingId,
}: {
  billingId?: string;
}) => {
  const [dataSummary, setDataSummary] = React.useState<IDataSummaryResult>();

  const { loading: getAllDataLoading, makeApiCall } = useApi({
    method: "GET",
    url: billingId
      ? `/rtm/summary-page/cron/pdf/data-summary/${billingId}`
      : "",
    preAuth: true,
  });

  const getDataSummary = async () => {
    if (!billingId) return;

    const { response, error } = await makeApiCall<
      undefined,
      IDataSummaryResponse
    >();

    if (response?.status === "success") {
      setDataSummary(response.result);
    } else if (error) {
      toast.error(error.msg);
      setDataSummary(undefined);
    }
  };

  React.useEffect(() => {
    getDataSummary();
  }, [billingId]);

  return { getAllDataLoading, dataSummary };
};

export default useGetBillingDataSummaryPdfPage;
